import { Helmet } from 'react-helmet-async'
import { MetadataProps } from './Metadata.types'

function Metadata({ props }: MetadataProps) {
  const { title, description } = props

  if (!title) return null

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name='description' content={description} />}
    </Helmet>
  )
}

export default Metadata
